import { render, staticRenderFns } from "./HeaderBox.vue?vue&type=template&id=5978869e&scoped=true&"
import script from "./HeaderBox.vue?vue&type=script&lang=js&"
export * from "./HeaderBox.vue?vue&type=script&lang=js&"
import style0 from "./HeaderBox.vue?vue&type=style&index=0&id=5978869e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5978869e",
  null
  
)

export default component.exports